export const externalLinkProps = {
  rel: 'no-referrer',
  target: '_blank',
};

export enum SiteLinks {
  READ_MORE = 'https://questpair.com/about-the-smart-ai-consultant/',
}
